import fetchMock from 'fetch-mock';

import { API_URL } from '../../../../config';

const SAMPLE_SIMULATION_ID = 'sample-simulation-id-walkthrough';
const SAMPLE_ALPHA_ID = 'sample-alpha-id-walkthrough';

const getAPI = (...paths: string[]) => `${API_URL}${paths.join()}`;

const getAlphasAPI = (subPath: string = '') => {
  return `${API_URL}/alphas/${SAMPLE_ALPHA_ID}${subPath}`;
};

type LoadResponseFn = () => Promise<{ default: Object }>;

const getResponse = (loadResponse: LoadResponseFn) => {
  return () =>
    loadResponse()
      .then(m => m.default)
      .catch(_error => 'An error occured while loading EditorIntro mock response');
};

// When showing walkthrough, it could be hard to wait for the simulation finished [^1]
// to allow they to go to the next step of walkthrough.
// => I decided to prefetch mock responses that needed for the first render.
// --
// [1]: In the next step of the clicking "Simulate button", we want user to focus the chart,
// but if the simulation is not finished on-time, the target element of the next step (chart element) would not be found.
const getSimulationStatus = getResponse(() => import(/* webpackPrefetch: true */ './simulations_status.json'));
const getAlpha = getResponse(() => import(/* webpackPrefetch: true */ './alphas_id.json'));
const getAlphaRecordSets = getResponse(/* webpackPrefetch: true */ () => import('./alphas_id_recordsets.json'));
const getAlphaRecordSetsYearlyStats = getResponse(/* webpackPrefetch: true */ () => import('./alphas_id_recordsets_yearly-stats.json'));

const getAlphaRecordSetsPNL = getResponse(() => import('./alphas_id_recordsets_pnl.json'));
const getAlphaRecordSetsSharpe = getResponse(() => import('./alphas_id_recordsets_sharpe.json'));
const getAlphaRecordSetsTurnover = getResponse(() => import('./alphas_id_recordsets_turnover.json'));

const setupEditorIntroMocks = () => {
  fetchMock.config.fallbackToNetwork = true;
  fetchMock
    .post(getAPI('/simulations'), 201, {
      response: {
        headers: {
          location: getAPI(`/simulations/${SAMPLE_SIMULATION_ID}`),
        },
      },
    })
    .get(getAPI(`/simulations/${SAMPLE_SIMULATION_ID}`), getSimulationStatus)
    .get(getAlphasAPI(), getAlpha)
    .patch(getAlphasAPI(), getAlpha)
    .get(getAlphasAPI('/recordsets'), getAlphaRecordSets)
    .get(getAlphasAPI('/recordsets/yearly-stats'), getAlphaRecordSetsYearlyStats)
    .get(getAlphasAPI('/recordsets/pnl'), getAlphaRecordSetsPNL)
    .get(getAlphasAPI('/recordsets/sharpe'), getAlphaRecordSetsSharpe)
    .get(getAlphasAPI('/recordsets/turnover'), getAlphaRecordSetsTurnover);
};

export default setupEditorIntroMocks;
